import { Checkbox, FormControlLabel, Paper, TextField, Typography } from '@material-ui/core';
import React, { useGlobal } from 'reactn';
import { NumberField } from '../../components/NumberField';
import { IGlobalState } from '../../states/GlobalState';
import { globalStyles } from '../../style/GlobalStyles';
import { API_elaboraSchedaBudget } from '../../utils/functions';
import { SchedaBudgetInputProps } from './InformazioniCosti';

export default function IscrizioneImpreseArtigiane(props: SchedaBudgetInputProps) {

    const gClasses = globalStyles();
    const action = "changeIscrizioneImpreseArtigiane";
    const { state } = props;
    const [global] = useGlobal<IGlobalState>();

    const handleChange = (e: any) => {
        let { name, value } = e.target;
        props.handleChange(action, name, value);
    };

    const handleChangeChecked = (e: any) => {
        let { name, checked } = e.target;
        props.handleChange(action, name, checked);
        API_elaboraSchedaBudget(props, global, e.target.name, e.target.checked, action, true);
    }

    const handleBlur = (e: any) => {
        API_elaboraSchedaBudget(props, global);
    }

    return (
        <Paper className={gClasses.mainPaper}>
            <Typography variant="h6">Presentazione su supporto informatico digitale o con modalità telematica, importo variabile da 15 a 35 euro secondo la Regione e Provincia di riferimento.</Typography>
            <div>
                <NumberField
                    name="J40_digita_importo"
                    label="Digita l'importo"
                    value={state.iscrizioneImpreseArtigiane.J40_digita_importo}
                    className={gClasses.textField}
                    onChange={handleChange} onBlur={handleBlur}
                />
            </div>
            <div>
                <NumberField
                    name="J42_maggiorazione_per_impresa_individuale"
                    label="Maggiorazione per impresa individuale"
                    value={state.iscrizioneImpreseArtigiane.J42_maggiorazione_per_impresa_individuale}
                    className={gClasses.textField}
                    onChange={handleChange} onBlur={handleBlur}
                    tooltip="La maggiorazione si applica alle imprese di cui alle Leggi: 46/1990 (Installazione impianti), 122/1992 (Autoriparazioni),  82/1994 (Pulizie) e 57/2001 (Facchinaggio)"
                />
                <Checkbox
                    checked={state.iscrizioneImpreseArtigiane.I42_maggiorazione_per_impresa_individuale}
                    name='I42_maggiorazione_per_impresa_individuale'
                    value={state.iscrizioneImpreseArtigiane.I42_maggiorazione_per_impresa_individuale}
                    inputProps={{ 'aria-label': 'primary checkbox' }}
                    onChange={handleChangeChecked}
                />
            </div>
            <div>
                <NumberField
                    name="J43_maggiorazione_per_societa"
                    label="Maggiorazione per società"
                    value={state.iscrizioneImpreseArtigiane.J43_maggiorazione_per_societa}
                    className={gClasses.textField}
                    onChange={handleChange} onBlur={handleBlur}
                    tooltip="La maggiorazione si applica alle imprese di cui alle Leggi: 46/1990 (Installazione impianti), 122/1992 (Autoriparazioni),  82/1994 (Pulizie) e 57/2001 (Facchinaggio)"
                />
                <Checkbox
                    checked={state.iscrizioneImpreseArtigiane.I43_maggiorazione_per_societa}
                    name='I43_maggiorazione_per_societa'
                    value={state.iscrizioneImpreseArtigiane.I43_maggiorazione_per_societa}
                    inputProps={{ 'aria-label': 'primary checkbox' }}
                    onChange={handleChangeChecked}
                />
            </div>
            <div>
                <TextField
                    id="C45_altro"
                    name="C45_altro"
                    label="Altro"
                    value={state.iscrizioneImpreseArtigiane.C45_altro}
                    onChange={handleChange} onBlur={handleBlur}
                    className={gClasses.textField}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    margin="dense"
                />
                <NumberField
                    name="J45_altro"
                    label=""
                    value={state.iscrizioneImpreseArtigiane.J45_altro}
                    className={gClasses.textField}
                    onChange={handleChange} onBlur={handleBlur}
                />
            </div>
        </Paper>
    )
}